import React, {FC, useEffect, useState} from "react";
import {ReactSortable} from "react-sortablejs";
import {ReactComponent as PointsIcon} from '../../../../../../../../../assets/main/test/points.svg';
import {Answer} from "features/model/types/test/getTestIdShema";
import {setAutoFreeze} from 'immer';

setAutoFreeze(false);

interface ItemType {
    answers: Answer[];
    onDragChange: (data: { questionId: number; answerDrag: { id: number; position: number; text: string }[] }) => void;
    questionId: number;

}

export const TestDrag = ({answers, questionId, onDragChange}: ItemType) => {
    const [state, setState] = useState([...answers]);


    const handleStateChange = (newState: Answer[]) => {
        const updatedState = newState.map((item, index) => ({
            ...item,
            position: index + 1,
            text: item.text
        }));

        setState(updatedState);

        const dataToSend = updatedState.map(item => ({ id: item.id, position: item.position, text: item.text }));
        onDragChange({ questionId, answerDrag: dataToSend });

    };

    return (
        <ReactSortable
            key={questionId}
            className="drag-words-list"
            list={state}
            animation={150}
            ghostClass="ghost-item"
            fallbackClass="word"
            setList={handleStateChange}
        >
            {state.map((item) => (
                <div key={item.id} className="word">
                    <PointsIcon/>
                    <span>{item.text}</span>
                </div>
            ))}
        </ReactSortable>
    );
};

